import { CircularProgress, FormControl, FormHelperText, InputBaseComponentProps, InputLabel, OutlinedInput, OutlinedInputProps } from "@mui/material"
import { ElementType } from "react"

interface IProps extends Omit<OutlinedInputProps, "placeholder" | "value" | "label"> { // Extende de SelectProps, omitindo props conflituosas
    label: string,
    value?: any,
    onChangeValue?: (newValue: any) => void,
    placeholder?: string,
    mask?: ElementType<InputBaseComponentProps, keyof JSX.IntrinsicElements>,
    helperText?: string,
    loading?: boolean
}
export const InputComponent = ({
    label,
    onChangeValue,
    placeholder,
    value,
    mask,
    helperText,
    error,
    loading,
    ...rest
}: IProps) => {
    return (
        <FormControl
            variant="outlined"
            sx={{ mb: !!helperText ? 1.5 : 0 }}
            error={!!error} // Adiciona o estado de erro visual
        >
            <InputLabel htmlFor={`${label.replaceAll(" ", "-")}-label`} sx={{
                opacity: rest.disabled || loading ? 0.5 : 1
            }}>
                {label}
            </InputLabel>
            <OutlinedInput
                inputComponent={mask}
                id={`${label.replaceAll(" ", "-")}-label`}
                placeholder={placeholder || ""}
                label={label}
                value={value}
                onChange={(e) => onChangeValue && onChangeValue(e.target.value)}
                endAdornment={loading && <CircularProgress size={20} sx={{ mr: .5 }} />}
                disabled={rest.disabled || loading}
                sx={{
                    opacity: rest.disabled || loading ? 0.5 : 1
                }}
                {...rest}
            />
            <FormHelperText>{helperText || ""}</FormHelperText>
        </FormControl>
    )
}